module.exports = __webpack_public_path__ + "static/media/3_4kimyd.c9f6808b.png";